// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"06d260a1","123":"9278d20f","138":"82319ed5","140":"b888f923","453":"9eaafed9","526":"a685231b","643":"e9329df4","901":"b76860ea","972":"eb5cb1b8"}[chunkId] + ".chunk.js";
};